import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Grid, TextField } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Color } from '../../../assets/color';
import * as AuthActions from '../../../redux/actions/authAction';

import '../../login/login.css';

const PartnerForgetPassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [inputFieldDetail, setInputFieldDetail] = useState({ email: '' });
    const [inputFieldError, setInputFieldError] = useState({});

    const handleInputFieldDetailError = (input, value) => setInputFieldError((prev) => ({ ...prev, [input]: value }));  //* Handle Input Field : Error
    const handleInputFieldDetail = (event) => setInputFieldDetail({ ...inputFieldDetail, [event?.target?.name]: event?.target?.value });  //* Handle Input Field : Data

    //! Handle Validation
    const handleValidation = () => {
        let isValid = true
        const { email } = inputFieldDetail;

        if (!email) { handleInputFieldDetailError("email", "Please Enter email"); isValid = false }
        return isValid;
    }

    //! Handle Submit
    const handleSubmit = () => {
        const { email } = inputFieldDetail;

        if (handleValidation()) {
            console.log({ ...inputFieldDetail });

            const payload = {
                data: { email },
                onComplete: () => navigate('/login')
            }
            //! Dispatching API For Login 
            dispatch(AuthActions.partnerForgetPassword(payload));
        }
    };

    return (
        <div style={{ backgroundSize: 'cover', backgroundRepeat: 'no-repeat', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
            <div className="loginWrapper slideInFromBottomAnimation" style={{ border: `1px solid ${Color.primary}` }}>
                <div style={{ padding: '2rem 0rem 0rem 2rem', maxWidth: '30rem', borderRadius: 20, backgroundColor: 'white', padding: "2rem" }}>
                    <Grid container spacing={2}>
                        <Grid item lg={12} sm={12} md={12} xs={12} >
                            <div style={{ display: 'flex', flexDirection: 'column', }}  >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <ArrowBack onClick={() => navigate(-1)} style={{ fontSize: 30, cursor: 'pointer' }} />
                                    <div style={{ fontSize: '1.6rem', }}>Forget password</div>
                                </div>
                                <div style={{ fontSize: '18px', marginTop: 10 }}>We will send you an email to reset your password</div>
                            </div>
                        </Grid>

                        <Grid item xs={12} sx={{ marginTop: '20px' }}>
                            <TextField label={<>Email <span style={{ color: "red" }}>*</span></>} variant="outlined" fullWidth
                                name="email"
                                value={inputFieldDetail?.email}
                                onChange={handleInputFieldDetail}
                                error={inputFieldError.email ? true : false}
                                helperText={inputFieldError.email}
                                onFocus={() => handleInputFieldDetailError("email", null)}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item lg={12} sm={12} md={12} xs={12} >
                            <div onClick={handleSubmit} style={{ padding: '15px 20px', textAlign: 'center', border: `1px solid ${Color.primary}`, borderRadius: '5px', backgroundColor: Color.primary, color: Color.white, fontSize: '16px', cursor: 'pointer' }}>Submit</div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    )

}
export default PartnerForgetPassword;
